<script lang="ts" setup>
import { EvaluationCriteria, TokenData } from "types/EvaluationResults";

const props = defineProps({
  criteria: {
    type: Object as PropType<EvaluationCriteria>,
    required: true,
  },
  tokenData: {
    type: Object as PropType<TokenData[]>,
    required: false,
  },
  showTokenData: {
    type: Boolean,
    default: false,
  },
  showHiddenCriteria: {
    type: Boolean,
    default: false,
  },
});

const label = computed(() => {
  return `${props.criteria.config?.text}`;
});

const isPassed = computed(() => {
  return props.criteria.passed;
});

const relevantInstances = computed(() => {
  return useSortRelevantInstances(props.criteria.relevantInstances);
});
</script>

<template>
  <div class="flex flex-col">
    <div
      class="flex flex-row items-center py-1"
      v-if="criteria.config?.isVisible == true || showHiddenCriteria == true"
      :class="{
        'bg-danger-default bg-opacity-10': criteria.isUnexpected == true,
      }"
    >
      <span v-if="criteria.config.isManual == true" class="w-[50px]"
        >&nbsp;</span
      >
      <span v-if="criteria.config.isManual != true" class="w-[50px]">
        <icon
          name="material-symbols:check-circle-rounded"
          class="text-success-default mr-2"
          v-if="isPassed"
        />
        <icon
          name="mdi:close-circle"
          class="text-danger-default mr-2"
          v-if="isPassed != true"
        />
        <BaseIconWand size="14" class="text-primary-default" />
      </span>
      <span class="mt-[1px]">
        {{ label }}
      </span>
    </div>
    <div
      class="flex flex-col"
      :class="{
      'ml-[50px]': showHiddenCriteria,
      }"
    >
      <DocumentProblemReviewTestingInstanceItem
        v-for="(instance, index) in relevantInstances"
        :key="index"
        :relevant-instance="instance"
        :criteria-config="criteria.config"
        :token-data="tokenData"
        :show-token-data="showTokenData"
        :show-hidden-criteria="showHiddenCriteria"
        :should-show-instances="criteria.config?.shouldShowInstances"
        class="pb-2 mb-2 border-b border-dashed"
      />
    </div>
  </div>
</template>

<style scoped></style>
